<template>

  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--添加门店-->
      <div class="common-form">新增物流公司</div>
      <el-form-item label="物流公司名称 " prop="express_name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.express_name" class="max-w460"></el-input>
        
      </el-form-item>
      <el-form-item label="物流公司代码(快递100) " prop="express_code" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.express_code" class="max-w460"></el-input>
        <div class="tips">用于快递100API查询物流信息，务必填写正确;请对照
          <el-link type="primary" :underline="false" @click="gotoCompany(0)">
            快递100物流公司编码表
          </el-link>
          填写
        </div>
      </el-form-item>
      <el-form-item label="物流公司代码(快递鸟) " prop="kdniao_express_code" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.kdniao_express_code" class="max-w460"></el-input>
        <div class="tips">用于快递鸟API查询物流信息，务必填写正确;请对照
          <el-link type="primary" :underline="false" @click="gotoCompany(1)">
            快递鸟物流公司编码表
          </el-link>
          填写
        </div>
      </el-form-item>
	  <el-form-item label="物流公司代码(微信) " prop="weixin_express_code" >
	    <el-input v-model="form.weixin_express_code" class="max-w460"></el-input>
	    <div class="tips">用于微信API查询物流信息，务必填写正确;请对照
	      <el-link type="primary" :underline="false" @click="gotoWxCompany()">
	        微信物流公司编码表
	      </el-link>
	      填写
	    </div>
	  </el-form-item>
      <el-form-item label="排序">
        <el-input v-model="form.sort" type="number" class="max-w460"></el-input>
        <div class="tips">数字越小越靠前</div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>


    </el-form>


  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';
  export default {
    data() {
      return {
        loading: false,
        /*form表单数据*/
        form: {
          express_name: '',
          express_code: '',
          sort: 1,
        },


      };
    },
    created() {},

    methods: {
      //提交表单
      onSubmit() {
        let self = this;
        let form = this.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            SettingApi.addExpress(form, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，添加成功',
                  type: 'success'
                });
                self.$router.push('/setting/express/index');
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });

      },
	  
	  gotoWxCompany(){
	    let baseUrl = window.location.protocol + '//' + window.location.host;
	    window.location.href = baseUrl + '/wx_express.xlsx';
	  },

      /*跳转物流编码*/
      gotoCompany(type=0) {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        if(type ==0){
          window.location.href = baseUrl + '/express.xlsx';
        }else{
          window.location.href = baseUrl + '/kdniaoexpress.xlsx';
        }
        
      }

    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/express/add.vue